<template>
  <div class="container">
    <el-tabs v-model="activeName" type="card" @tab-click="handlclick">
      <el-tab-pane label="直属经销商" name="1">
        <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
          <el-form-item label="经销商:">
            <el-col :span="16">
              <el-input v-model="form1.dealer_sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button type="primary" @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="经销商级别:">
            <el-select v-model="form1.dealer_level_id" placeholder="请选择经销商级别" clearable>
              <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型:">
            <el-select v-model="form1.settlement_type">
              <el-option label="全部" value></el-option>
              <el-option label="订单返利" value="1"></el-option>
              <el-option label="返利结算" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间:" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form1.start_time"
                style="width: 100%;"
                clearable
              ></el-date-picker>
            </el-col>
            <el-col :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form1.end_time"
                style="width: 100%;"
                clearable
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button @click="exportData(1)">导出</el-button>
          </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          border
          stripe
          height="400"
          style="width: 100%;margin-top: 20px"
        >
          <el-table-column prop="dealer_sn" label="经销商编号"></el-table-column>
          <el-table-column prop="dealer_name" label="经销商名称"></el-table-column>
          <el-table-column prop="dealer_level_name" label="经销商级别"></el-table-column>
          <el-table-column prop="account_balance" label="余额变动" show-overflow-tooltip>
            <template
              slot-scope="scope"
            >{{scope.row.settlement_type==1?'+'+scope.row.settlement_money:'-'+scope.row.settlement_money}}</template>
          </el-table-column>
          <el-table-column prop label="类型" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.settlement_type==1?'订单返利':'返利结算'}}</template>
          </el-table-column>
          <el-table-column prop="created_at" label="时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="account_balance" label="账户余额" show-overflow-tooltip></el-table-column>
          <el-table-column prop label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="非直属经销商" name="2">
        <el-form ref="form2" :model="form2" label-width="100px" :inline="true" class="mt20">
          <el-form-item label="经销商:">
            <el-col :span="16">
              <el-input v-model="form2.dealer_sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button type="primary" @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="经销商级别:">
            <el-select v-model="form2.dealer_level_id" placeholder="请选择经销商级别" clearable>
              <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型:">
            <el-select v-model="form2.settlement_type">
              <el-option label="全部" value></el-option>
              <el-option label="订单返利" value="1"></el-option>
              <el-option label="返利结算" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间:" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form2.start_time"
                style="width: 100%;"
                clearable
              ></el-date-picker>
            </el-col>
            <el-col :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form2.end_time"
                style="width: 100%;"
                clearable
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button @click="exportData(2)">导出</el-button>
          </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
          ref="multipleTable"
          :data="tableData2"
          border
          v-loading="loading"
          stripe
          height="400"
          style="width: 100%;margin-top: 20px"
        >
          <el-table-column prop="dealer_sn" label="经销商编号"></el-table-column>
          <el-table-column prop="dealer_name" label="经销商名称"></el-table-column>
          <el-table-column prop="dealer_level_name" label="经销商级别"></el-table-column>
          <el-table-column prop="superior_dealer_name" label="上级经销商"></el-table-column>
          <el-table-column prop="account_balance" label="余额变动" show-overflow-tooltip>
            <template
              slot-scope="scope"
            >{{scope.row.settlement_type==1?'+'+scope.row.settlement_money:'-'+scope.row.settlement_money}}</template>
          </el-table-column>
          <el-table-column prop label="类型" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.settlement_type==1?'订单返利':'返利结算'}}</template>
          </el-table-column>
          <el-table-column prop="created_at" label="时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="account_balance" label="账户余额" show-overflow-tooltip></el-table-column>
          <el-table-column prop label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <detaiDialog
      v-if="detaiDialogVisable"
      :prop="propData"
      v-on:handleClose="detaiDialogVisable = false"
    ></detaiDialog>
    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
  </div>
</template>

<script>
import detaiDialog from "./detail";
import selectDealer from "@/components/logistics/common/selectDealer.vue";
export default {
  name: "touch-balance",
  data() {
    return {
      selectDealerDialog: false,
      detaiDialogVisable: false,
      activeName: "1",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      pageNo1: 1,
      pageSize1: 10,
      totalSize1: 0,
      tableData1: [{}],
      tableData2: [{}],
      form1: {
        to_sn: "",
        dealerLevel: "",
        start_time: "",
        end_time: "",
        settlement_type: "",
        dealer_sn: "",
        dealer_level_id: ""
      },
      form2: {
        to_sn: "",
        dealerLevel: "",
        sort: "",
        start_time: "",
        end_time: "",
        settlement_type: "",
        dealer_sn: "",
        dealer_level_id: ""
      },
      dealerLevel: [],
      propData: {}
    };
  },
  methods: {
    //获取经销商级别
    getDealerLevel() {
      this.$get("logistics", "/dealers.level", {})
        .then(res => {
          //console.log(res);
          this.dealerLevel = res.data;
        })
        .catch(function(error) {
        });
    },
    exportData(temp) {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
    
      if (temp == 1) {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form2.end_time) {
          endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        window.open(
         this.$Base_Export+
            "/dealers.balances.logs.export?is_parent=" +
            this.activeName +
            "&lang=" +
            "" +
            "&start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&is_export=1" +
            "&dealer_level_id=" +
            this.form1.dealer_level_id +
            "&dealer_sn=" +
            this.form1.dealer_sn +
            "&is_parent =" +
            this.active +
            "&settlement_type=" +
            this.form1.settlement_type +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form2.start_time) {
          beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD");
        }
        if (this.form2.end_time) {
          endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
        }
        window.open(
          url +
            process.env.VUE_APP_URL +
            "/dealers.balances.logs.export?is_parent="+
            this.activeName+
            "&start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&dealer_level_id=" +
            this.form2.dealer_level_id +
            "&dealer_sn=" +
            this.form2.dealer_sn +
            "&settlement_type=" +
            this.form2.settlement_type+
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    onSearch() {
      if (this.activeName == 1) {
        var obj = {
          ...this.form1
        };
        obj.page = 1;
        obj.per_page = 10;
      } else {
        var obj = {
          ...this.form2
        };
        obj.page = 1;
        obj.per_page = 10;
      }
      this.loading = true;
      this.tableData2 = [];
      this.tableData1 = [];
      this.$get("logistics", "/dealers.balances.logs", {
        is_parent: this.activeName,
        ...this.obj
      }).then(res => {
        this.loading = false;
        this.tableData2 = res.data;
        this.tableData1 = res.data;
        this.totalSize1 = res.meta.total;
        this.totalSize2 = res.meta.total;
      });
    },
    getList() {
      if (this.activeName == 1) {
        var obj = {
          ...this.form1
        };
        obj.page = this.pageNo;
        obj.per_page = this.pageSize;
      } else {
        var obj = {
          ...this.form2
        };
        obj.page = this.pageNo1;
        obj.per_page = this.pageSize1;
      }
      this.loading = true;
      this.tableData2 = [];
      this.tableData1 = [];
      this.$get("logistics", "/dealers.balances.logs", {
        is_parent: this.activeName,
        ...this.obj
      }).then(res => {
        this.loading = false;
        this.tableData2 = res.data;
        this.tableData1 = res.data;
        this.totalSize1 = res.meta.total;
        this.totalSize2 = res.meta.total;
      });
    },
    detail(data) {
      this.propData = data;
      this.detaiDialogVisable = true;
    },
    handleCurrentChange1() {
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    handleSizeChange1() {
      this.getList();
    },
    handleSizeChange() {
      this.getList();
    },
    handlclick() {
      this.getList();
    },
    getSelectinfo(val) {
      console.log(this.activeName);
      if (this.activeName == 1) {
        this.form1.dealer_sn = val.dealer_sn;
      } else {
        this.form2.dealer_sn = val.dealer_sn;
      }
    }
  },
  created() {
    this.getDealerLevel();
    this.getList();
  },
  components: {
    detaiDialog,
    selectDealer
  }
};
</script>

<style lang="scss" scoped>
</style>